export default "__VITE_ASSET__0v227JuJ__"